function Dd7DetailCtrl(toaster, $scope, $state, $stateParams, $rootScope, Dd7Service) {
  'ngInject';

  const vm = this;
  vm.orgId = $stateParams.orgId;
  console.log('DD7Detail init - $stateParams.orgId:', $stateParams.orgId, '$rootScope.currentOrg:', $rootScope.currentOrg);
  vm.loading = true;
  vm.posting = false;
  vm.run = null;
  
  // Make Math available in template
  $scope.Math = Math;

  vm.init = function() {
    vm.loadRun();
  };

  vm.loadRun = function() {
    vm.loading = true;
    Dd7Service.getAccrualRun($stateParams.orgId, $stateParams.runId, function(response) {
      vm.loading = false;
      if (response.status == 200) {
        vm.run = response.data.accrual_run;
      } else {
        toaster.pop('error', 'Error', 'Failed to load accrual run');
      }
    });
  };

  vm.postToXero = function() {
    vm.posting = true;
    Dd7Service.postToXero($stateParams.orgId, $stateParams.runId, function(response) {
      vm.posting = false;
      if (response.status == 200) {
        toaster.pop('success', 'Success', response.data.message || 'Posted to Xero');
        vm.loadRun();
      } else {
        toaster.pop('error', 'Error', response.data.error || 'Failed to post');
      }
    });
  };

  vm.goBack = function() {
    var currentOrgId = $stateParams.orgId || $state.params.orgId;
    console.log('DD7Detail goBack - orgId:', currentOrgId, 'vm.orgId:', vm.orgId);
    $state.go('user.organization.dashboard.dd7.list', { orgId: currentOrgId }, { inherit: false });
  };

  vm.getStatusClass = function(status) {
    switch(status) {
      case 'done': return 'label-success';
      case 'ready': return 'label-info';
      case 'pending': return 'label-warning';
      case 'mapping': return 'label-danger';
      case 'error': return 'label-danger';
      default: return 'label-default';
    }
  };

  vm.formatCurrency = function(amount) {
    if (amount === null || amount === undefined) return '-';
    var num = parseFloat(amount);
    var prefix = num < 0 ? '-$' : '$';
    return prefix + Math.abs(num).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };

  // Initialize on load
  vm.init();
}

Dd7DetailCtrl.$inject = ['toaster', '$scope', '$state', '$stateParams', '$rootScope', 'Dd7Service'];

export default {
  name: 'Dd7DetailCtrl',
  fn: Dd7DetailCtrl
};
